import React from 'react';
import agreementData from '../agreement.json';
import PolicyLayout from './PolicyLayout';

const TermsOfService = () => {
  return <PolicyLayout data={agreementData} />;
};

export default TermsOfService;
